import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './App.css';
import Main from './pages';
// SPEC-2026-07-03 product analytics — auto page_view + bandeau consentement 2 niveaux.
import usePageTracking from './hooks/usePageTracking';
import ConsentBanner from './components/ConsentBanner';

const RTL_LANGS = new Set(['ar']);

function App() {
  const { i18n } = useTranslation();

  // Analytics : émet un page_view à chaque navigation (contexte BrowserRouter).
  usePageTracking();

  useEffect(() => {
    const lang = i18n.language || 'en';
    const base = lang.split('-')[0];
    document.documentElement.dir = RTL_LANGS.has(base) ? 'rtl' : 'ltr';
    document.documentElement.lang = base;
  }, [i18n.language]);

  return (
    <>
    <Main/>
    <ConsentBanner/>
    </>
  );
}

export default App;
